<template>
    <div id="app">
        <v-app id="inspire">
            <v-card>
                <v-card-title>
                    PLANES DE AUDITORÍAS INTERNAS
                </v-card-title>
                <v-card-text>
                    <table border="1" width="50%">
                        <tr>
                            <td width="35%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">Plan</font>
                                    </b></p>
                            </td>
                            <td width="35%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">Elaboró</font>
                                    </b></p>
                            </td>
                            <td>
                                <p align="center"><b>
                                        <font face="Verdana" size="1">Fecha</font>
                                    </b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="35%" align="center">
                                <span style="font-family: Verdana; font-size: 12px; cursor: pointer; color: blue;"
                                    @click="verPdf('Plan2025')">Plan 2025</span>
                            </td>
                            <td width="35%" align="center">
                                <font face="Verdana" size="2">Blanco Sergio</font>
                            </td>
                            <td align="center">
                                <font face="Verdana" size="2">06/02/2025</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="35%" align="center">
                                <span style="font-family: Verdana; font-size: 12px; cursor: pointer; color: blue;"
                                    @click="verPdf('Plan2024')">Plan 2024</span>
                            </td>
                            <td width="35%" align="center">
                                <font face="Verdana" size="2">Blanco Sergio</font>
                            </td>
                            <td align="center">
                                <font face="Verdana" size="2">08/02/2024</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="35%" align="center">
                                <span style="font-family: Verdana; font-size: 12px; cursor: pointer; color: blue;"
                                    @click="verPdf('Plan2023')">Plan 2023</span>
                            </td>
                            <td width="35%" align="center">
                                <font face="Verdana" size="2">Blanco Sergio</font>
                            </td>
                            <td align="center">
                                <font face="Verdana" size="2">16/02/2023</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="35%" align="center">
                                <span style="font-family: Verdana; font-size: 12px; cursor: pointer; color: blue;"
                                    @click="verPdf('Plan2022')">Plan 2022</span>
                            </td>
                            <td width="35%" align="center">
                                <font face="Verdana" size="2">Musso Marcos</font>
                            </td>
                            <td align="center">
                                <font face="Verdana" size="2">10/03/2022</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="35%" align="center">
                                <span style="font-family: Verdana; font-size: 12px; cursor: pointer; color: blue;"
                                    @click="verPdf('Plan2021')">Plan 2021</span>
                            </td>
                            <td width="35%" align="center">
                                <font face="Verdana" size="2">Musso Marcos</font>
                            </td>
                            <td align="center">
                                <font face="Verdana" size="2">11/05/2021</font>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
            </v-card>
            <VerPdf :visible="showPdf" :codigo="this.doc" @close="showPdf = false">
            </VerPdf>
        </v-app>
    </div>
</template>

<script>
import VerPdf from "../Auditoria/Visualizarpdf.vue";
export default {
    components: { VerPdf },
    data: (vm) => ({
        doc: "",
        showPdf: false,
    }),
    computed: {
        show: {
            get() {

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        verPdf(item) {
            this.doc = item;
            this.showPdf = true;
        },
    },
};
</script>